import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const useBusiness = () => {
  const route = useRouter();

  const [isBusiness, setIsBusiness] = useState(false);
  useEffect(() => {
    const isBusinessPage = route.pathname.startsWith('/business');
    setIsBusiness(isBusinessPage);

    if (isBusinessPage) {
      document.documentElement.classList.add('business');
    } else {
      document.documentElement.classList.remove('business');
    }
  }, [route.pathname]);

  return isBusiness;
};
